import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
export const FooterMessageRoot = styled('div', {
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingBottom: '40px',
  margin: 'auto',
  position: 'relative',

  '& strong': {
    fontWeight: '$semiBold'
  },

  '& .m-only': {
    display: 'block',
  },
  '& .d-only': {
    display: 'none',
  },

  '@bp2': {
    paddingLeft: '120px',
    paddingRight: '120px',
    paddingBottom: '102px',
    '& .m-only': {
      display: 'none',
    },
    '& .d-only': {
      display: 'block',
    },
  },
})

export const FooterCard = styled('div', {
  background: '$accent-white',
  borderRadius: '20px',
  border: '1px solid $primary-700',
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '20px',
  paddingBottom: '20px',
  zIndex: 1,
  position: 'relative',
  margin: 'auto',

  '@bp1': {
    paddingLeft: '80px',
    paddingRight: '80px',
  },

  '@bp2': {
    maxWidth: '852px',
  },
})

export const TextColumn = styled(Stack, {
  maxWidth: 'none',
  '@bp2': {
    maxWidth: '800px',
  }
})

export const FooterBanner = styled('div', {
  width: '100dvw',
  height: '177px',
  position: 'absolute',
  top: '70px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: '$primary-700',
  zIndex: 0,
})